interface Props {
  num: string;
  label: string;
  title: string;
  lead?: string;
}

export function SectionHead({ num, label, title, lead }: Props) {
  return (
    <div className="section-h">
      <div className="sec-label"><span className="num">{num}</span>{label}</div>
      <div>
        <h2>{title}</h2>
        {lead && (
          <p style={{ marginTop: 14, color: 'var(--fg-soft)', fontSize: 16, maxWidth: '60ch', lineHeight: 1.55 }}>
            {lead}
          </p>
        )}
      </div>
    </div>
  );
}
